import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { TreatmentsService } from '../../../_services/treatments/treatments.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CustomersService } from '../../../_services/customers/customers.service';
import ITreatment from '../../../_interfaces/ITreatment';
import { BaseComponent } from '../../../components/base/base.component';
import { SessionService } from '../../../_services/session/session.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { AdminTableActionsComponent } from '../../admin-ui/admin-table-actions/admin-table-actions.component';
import { AdminListToolbarComponent } from '../../admin-ui/admin-list-toolbar/admin-list-toolbar.component';
import { AdminStatePanelComponent } from '../../admin-ui/admin-state-panel/admin-state-panel.component';

@Component({
  standalone: true,
  selector: 'app-table-treatments',
  templateUrl: './table-treatments.component.html',
  styleUrls: ['./table-treatments.component.scss'],

  imports: [
    CommonModule,
    TableModule,
    TranslatePipe,
    ButtonModule,
    AdminTableActionsComponent,
    AdminListToolbarComponent,
    AdminStatePanelComponent,
  ],
})
export class TableTreatmentsComponent extends BaseComponent implements OnInit {
  public treatments: ITreatment[] = [];
  public filteredTreatments: ITreatment[] = [];
  public searchValue = '';

  constructor(
    private treatmentsService: TreatmentsService,
    private messageService: MessageService,
    private errorsService: ErrorsService,
    private confirmationService: ConfirmationService,
    public translate: TranslateService,
    public session: SessionService,
    public customersService: CustomersService,
    public router: Router,
  ) {
    super(session);
  }

  load() {
    this.customersService.getTreatments(this.customers_id).subscribe({
      next: (treatments: ITreatment[]) => {
        this.treatments = treatments;
        this.onSearch(this.searchValue);
      },
      error: (err: HttpErrorResponse) => {
        const code = this.errorsService.getMessageFromTreatmentError(err);
        this.messageService.add({
          severity: 'error',
          detail: this.translate.instant(`MESSAGES.TREATMENTS.ERROR.${code}`),
          summary: this.translate.instant(`MESSAGES.TREATMENTS.ERROR.SUMMARY`),
        });
      },
    });
  }

  onSearch(value: string): void {
    this.searchValue = value;
    const query = value.trim().toLowerCase();
    if (!query) {
      this.filteredTreatments = [...this.treatments];
      return;
    }
    this.filteredTreatments = this.treatments.filter((treatment) =>
      [treatment.name, treatment.description, treatment?.category?.name]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .includes(query),
    );
  }

  confirmDelete(treatment: ITreatment): void {
    this.confirmationService.confirm({
      header: this.translate.instant('ADMIN.TREATMENTS.CONFIRM.DELETE.TITLE', {
        treatment: treatment.name,
      }),
      message: this.translate.instant('ADMIN.TREATMENTS.CONFIRM.DELETE.TEXT', {
        treatment: treatment.name,
      }),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.delete(treatment),
    });
  }

  private delete(treatment: ITreatment): void {
    this.treatmentsService.delete(this.customers_id, treatment.id as number).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('MESSAGES.TREATMENTS.DELETE.SUMMARY'),
          detail: this.translate.instant('MESSAGES.TREATMENTS.DELETE.DETAIL', {
            treatment: treatment.name,
          }),
        });
        this.load();
      },
      error: (err: HttpErrorResponse) => {
        const code = this.errorsService.getMessageFromTreatmentError(err);
        this.messageService.add({
          severity: 'error',
          detail: this.translate.instant(`MESSAGES.TREATMENTS.ERROR.${code}`),
          summary: this.translate.instant('MESSAGES.TREATMENTS.ERROR.SUMMARY'),
        });
      },
    });
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.load();
  }
}
